<div [ngClass]="{'subBlockContainer': !setFullWindow , 'subBlockContainer_full':setFullWindow}">
    <div class="subBlockContent" id="addWGSProduct">
        <child-header [title]="title" (click)="close()" ></child-header>

        <div #ParentWrapper class="child-body">
            <div class="inner-subBlock-wrapper">

                <div class="row filter-wrapper">
                    <div class="searchInputGroup" style="width: auto;margin-left:10px;">
                        <div class="searchIcon">
                            <img src="../images/new_ui/filter.png">
                        </div>
                        <input class="searchInput" type="text" #searchValue placeholder="Filter" [(ngModel)]="searchSubscriotion" onfocus="this.placeholder=''" onblur="this.placeholder='Filter'" (ngModelChange)="filterSubscriptionItems()">
                    </div>
                   <div class="row" class="col-md-4" style="margin-left: -110px;margin-top: -13px">                     
                            <ng-select class="customDropdwon" [items]="wgsFamilyList" bindValue="value" bindLabel="displayText" placeholder="Family" [(ngModel)]="selectedwgsSubscriptionType" (ngModelChange)="loadingFamilyItems($event)">
                            </ng-select>                        
                        <mat-spinner mode="indeterminate" class="circle cSPCustomerEntitlements-loading" diameter="20" style="position: relative;top:15px" *ngIf="isLoadingListView">
                        </mat-spinner>                       
                    </div> 
                    <div class="row" class="col-md-4" style="margin-right: 120px;margin-top: -13px">
                                          <!--  <div class="col-md-4"> -->
                             <ng-select class="customDropdwon" [items]="wgsModelList" bindValue="value" bindLabel="displayText" placeholder="Model" [(ngModel)]="selectedwgsSubscriptionType" (ngModelChange)="loadingModelItems($event)">
                             </ng-select>
                         <!-- </div> -->
                         <mat-spinner mode="indeterminate" class="circle cSPCustomerEntitlements-loading" diameter="20" style="position: relative;top:15px" *ngIf="isLoadingListView">
                         </mat-spinner>
                        
                     </div> 
                </div>
                
                
                <loading-screen *ngIf="isLoadingContent" [showBlurTable]="true" (currentLoadingStatus)="onLoading($event)">
                </loading-screen>
                
                <div *ngIf="!isLoadingContent">
                    <ng-container>

                        <div class="col-md-12 align-center" *ngIf="!subscriptionItems?.length && !isLoadingContent">
                            <label class="noData-label">
                                <!-- We couldn’t find any annuity items -->
                            </label>
                        </div>

                        <div class="x-margin-top"  *ngIf="subscriptionItems?.length && !isLoadingContent"  >
                            <div class="mTable">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th scope="col" class="align-left" style="width: 60%">DESCRIPTION</th>
                                            <th scope="col" class="align-right" style="width: 20%; text-align: right;">BUY PRICE</th>
                                            <th scope="col" class="align-center" style="width: 10%">QTY</th>
                                            <th scope="col" class="align-center" style="width: 10%"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let annuityItem of subscriptionItemsFilter">
                                            <td>
                                                <span  class="description-popup">{{annuityItem?.description}}</span>                                                                                                                                          
                                                <div class="result-info">
                                                    <div class="produc-secondary-title-wrapper">
                                                        <span class="light-text">STOCK CODE:&nbsp;</span>
                                                        <span >{{annuityItem?.stockCode}}</span>
                                                    </div>
                                                </div>
                                            </td>                             
                                            <td  class="align-right" style="position: relative;vertical-align: middle;text-align: right;">
                                                {{annuityItem?.itemPrice}}
                                                <span>/mth</span>
                                            </td>
                                            <td class="align-center" style="position: relative;vertical-align: middle;">
                                                <input class="align-center input-wrapper input-wrapper-small" [disabled]="true" [(ngModel)]="annuityItem.quantity" (keypress)="_keyPress($event)" type="text" (blur)="changeQty(annuityItem)">
                                                <mat-icon matSuffix class="editmpnidicon align-top" *ngIf="annuityItem?.minMaxQtyText" placement="bottom" ngbTooltip="{{annuityItem?.minMaxQtyText}}">info</mat-icon>
                                            </td>
                                            <td class="align-center" style="vertical-align: middle;">
                                                <button id="{{annuityItem?.stockCode}}" class="button button-red button-mid confirmbutton" *ngIf="!annuityItem?.isExisting" (click)="addSubscriptionItem(annuityItem)">Add</button>
                                                <button id="{{annuityItem?.stockCode}}" class="button button-red button-mid confirmbutton" *ngIf="annuityItem?.isExisting" (click)="addSubscriptionItem(annuityItem)">Update</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </ng-container>
                </div>
            </div>
        </div>
    </div>

    <ng-container *ngIf="showSideBar">
        <div style="margin-left: 1px;" class="subBlockContent" id="addProductSideBar">
            <child-header [title]="title" (closeEvent)="closeSideBar()"></child-header>
            <div class="child-body">
                <div class="inner-subBlock-wrapper">
                    <ng-container>
                        <div>
                            <div class="searchInputGroup" style="width: 186px;margin:auto;margin-bottom: 15px;">
                                <div class="searchIcon search-carts">
                                    <img src="../images/new_ui/filter.png">
                                </div>
                                <input class="searchInput" type="text" placeholder="Filter" onfocus="this.placeholder=''"
                                    onblur="this.placeholder='Filter'" [(ngModel)]="sideBarSubscriptionSearch">
                            </div>
                            <ng-container *ngFor="let item of subscriptionItemsPendingList;index as i">
                                <ng-container
                                    *ngIf="item.description.toLowerCase().includes(sideBarSubscriptionSearch.toLowerCase())">
                                    <div class="menu-wrapper menu-wrapper-position">
                                        <div class="total-div pr-2">
                                            <div class="narrow-title">{{item.description}}</div>
                                            <span class="narrow-text">Price:{{item.itemPrice}} |
                                                Quantity:
                                                {{item.quantity}}</span>
                                        </div>
                                        <div class="icon">
                                            <span class="basic-icon delete-icon information-icon-position"
                                                ngbTooltip="Remove" (click)="removeSubscriptionPendingItem(i)"></span>
                                        </div>
                                    </div>
                                </ng-container>
                            </ng-container>
                            <div class="align-center mt-3">
                                <button class="button button-red button-mid btn-csp"
                                    [disabled]="subscriptionItemsPendingList.length==0"
                                    (click)="confirmProduct()">Confirm</button>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </ng-container>

    <router-outlet></router-outlet>
</div>
